// import React, { useContext } from 'react';
// import { IMSContext } from './IMSformCategtorySelect';

// const withSelectedCategory = (WrappedComponent) => {
//   return (props) => {
//     const { selectedCategory } = useContext(IMSContext);
//     return <WrappedComponent {...props} selectedCategory={selectedCategory} />;
//   };
// };

// export default withSelectedCategory;

import React from 'react'
import { useAssetDrawerStore } from './AssetPropertiesDrawer/assetDrawerStore'

const withIsTabClicked = (WrappedComponent) => {
    return (props) => {
        const { isTabClicked } = useAssetDrawerStore();

        return <WrappedComponent {...props} isTabClicked={isTabClicked} />
    }
}

export default withIsTabClicked
